// src/components/shared/person/index.ts
import {
  PersonRoot,
  PersonAvatar,
  PersonName,
  PersonStatus,
  PersonEmail,
  PersonAbrangencia,
} from "./Person";

export const Person = {
  Root: PersonRoot,
  Avatar: PersonAvatar,
  Name: PersonName,
  Email: PersonEmail,
  Status: PersonStatus,
  Abrangencia: PersonAbrangencia,
};
